import { render, staticRenderFns } from "./JobContent.vue?vue&type=template&id=5addb9df&"
import script from "./JobContent.vue?vue&type=script&lang=js&"
export * from "./JobContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports